/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Exit: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_939)'>
      <path
        d='M8 24C7.79145 24.0005 7.58808 23.9351 7.419 23.813L0.419 18.813C0.289531 18.7206 0.183979 18.5986 0.111106 18.4572C0.0382334 18.3158 0.000143776 18.1591 0 18L0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0C1.388 0 2.185 0.624 2.316 0.718L8.582 5.2C8.7117 5.29282 8.81731 5.41532 8.89003 5.55727C8.96274 5.69922 9.00045 5.85651 9 6.016V23C9.00019 23.1838 8.94971 23.3642 8.85409 23.5212C8.75847 23.6782 8.62142 23.8058 8.458 23.89C8.31602 23.9619 8.15916 23.9996 8 24Z'
        fill='currentColor'
      />
      <path d='M11 13V19H14C14.2652 19 14.5196 18.8946 14.7071 18.7071C14.8946 18.5196 15 18.2652 15 18V13H11Z' fill='currentColor' />
      <path
        d='M11 6.016V7H15V1C15 0.734784 14.8946 0.48043 14.7071 0.292893C14.5195 0.105357 14.2652 0 14 0L4.75098 0L9.75098 3.576C10.1373 3.85497 10.4519 4.22159 10.669 4.64574C10.8861 5.0699 10.9996 5.5395 11 6.016Z'
        fill='currentColor'
      />
      <path d='M24 10L18 5V9H11V11H18V15L24 10Z' fill='currentColor' />
    </g>
    <defs>
      <clipPath id='clip0_20400_939'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
